<rt-select2
  #select
  [formControl]="control()"
  [searchControl]="searchControl"
  [disableLocalSearch]="true"
  [items]="options()"
  [disabled]="isReadOnly()"
  [hiddenItems]="preselectedOptions()"
  withSearch
  (vsUpdate)="onScrollChange($event)"
  (selection)="onSelectChange($event)"
>
  <rt-select-trigger
    [isInvalid]="isInvalid()"
    [isReadOnly]="isReadOnly()"
    [hasClearButton]="true"
  />
  <ng-template rtSelectEmptyState>
    <rt-dropdown-item>
      {{ 'app.common.no_results_found' | translate }}
    </rt-dropdown-item>
  </ng-template>
</rt-select2>
